import axiosApiInstance from '../../../api/axiosClient';
import type { SocialMetricsReport } from './types';

const CREATE_TIMEOUT_MS = 10 * 60 * 1000;

export async function listReports(): Promise<SocialMetricsReport[]> {
    const res = await axiosApiInstance.get<SocialMetricsReport[]>('/api/social-metrics/reports');
    return res.data ?? [];
}

export async function getReport(id: number): Promise<SocialMetricsReport> {
    const res = await axiosApiInstance.get<SocialMetricsReport>(`/api/social-metrics/reports/${id}`);
    return res.data;
}

export async function createReport(body: {
    platform: string;
    account: string;
    start_date?: string;
    end_date?: string;
}): Promise<SocialMetricsReport> {
    const res = await axiosApiInstance.post<SocialMetricsReport>('/api/social-metrics/reports', body, {
        timeout: CREATE_TIMEOUT_MS,
    });
    return res.data;
}

export async function getPublicReport(token: string): Promise<SocialMetricsReport> {
    const res = await axiosApiInstance.get<SocialMetricsReport>(`/api/public/social-metrics-reports/${token}`, {
        skipErrorNotification: true,
    });
    return res.data;
}

export async function setReportShare(reportId: number, enabled: boolean): Promise<{ share_token: string | null }> {
    const res = await axiosApiInstance.patch<{ share_token: string | null }>(
        `/api/social-metrics/reports/${reportId}/share`,
        { enabled },
    );
    return res.data;
}

export async function downloadExcel(id: number, fallbackName: string) {
    const res = await axiosApiInstance.get<Blob>(`/api/social-metrics/reports/${id}/excel`, {
        responseType: 'blob',
        timeout: 120000,
    });
    const header = String(res.headers['content-disposition'] ?? '');
    const match = header.match(/filename="([^"]+)"/);
    const name = match?.[1] || fallbackName;
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    a.click();
    URL.revokeObjectURL(url);
}
